// extracted by mini-css-extract-plugin
export default {"Card":"Card_Card__eTo4u","Overlay":"Card_Overlay__SxrxS","Position":"Card_Position__x1OYH","ViewMore":"Card_ViewMore__tlToV"};